import { createFileRoute } from "@tanstack/react-router";
import NameDetailPage from "@/site/pages/name-detail";

export const Route = createFileRoute("/name/$name")({
  component: NameDetailPage,
});
